import {WlSubmit} from "../../../common/ts/webcomponents/events/WlSubmit";

export class GeoHubMarketStats {
    private readonly container: HTMLElement | null;
    private readonly trovitTypeDropdown: HTMLInputElement | null | undefined;

    constructor() {
        this.container = document.querySelector('.js-market-stats-container')
        this.trovitTypeDropdown = this.container?.querySelector('.js-market-stats-filters__dropdown');
    }

    init() {
        if (this.container) {
            this.showMarketStatsByOperationType();
            this.registerEvents();
        }
    }

    private registerEvents() {
        this.registerTrovitTypeClickEvent();
    }

    private registerTrovitTypeClickEvent() {
        this.trovitTypeDropdown?.addEventListener(WlSubmit.type, this.selectorChanged)
    }

    private selectorChanged = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        this.hideAllMarketsStats();
        this.showMarketStatsByOperationType();
    }

    private hideAllMarketsStats() {
        this.container?.querySelectorAll('.market-stats-by-operation-type').forEach((marketStatsDiv) => {
            marketStatsDiv.classList.remove('visible');
        });
    }

    private showMarketStatsByOperationType() {
        this.container?.querySelector(`.js-market-stats-${(this.getOperationTypeSelected())}`)?.classList.add('visible');
    }

    private getOperationTypeSelected() {
        return this.trovitTypeDropdown!.value;
    }
}

window.addEventListener("load", () => {
    new GeoHubMarketStats().init();
});